import React, { memo, useEffect } from 'react';
import { useForceUpdate } from 'Hooks';
import SadFile from 'Images/sad-file.svg';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const UnexpectedError = ({
  reset
}) => {
  const update = useForceUpdate();
  useEffect(() => {
    const sub = mediator.subscribe('langChange:success', () => {
      window.setTimeout(update, 0);
    });
    return () => {
      mediator.remove(sub.id);
    };
  }, [update]);
  return /*#__PURE__*/React.createElement("div", {
    className: `container py-5 d-flex flex-column align-items-center justify-content-center h-100 `
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "sad-file",
    src: SadFile
  })), /*#__PURE__*/React.createElement("div", {
    className: `text-danger mb-3 text-xxxl line-height-normal`
  }, i18n.t('UnexpectedError.title')), /*#__PURE__*/React.createElement("div", {
    className: "w-100 text-center pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-steel line-height-normal"
  }, i18n.t('UnexpectedError.description'))), process.env.NODE_ENV !== 'production' ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary mt-3",
    onClick: reset
  }, "DEV ONLY - refresh component") : null);
};
export default /*#__PURE__*/memo(UnexpectedError);